<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    item-text="name"
    item-value="name"
    :rules="rules"
    :value="value"
    @input="onChange"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";

export default {
  name: "TablePicker",

  props: ["title", "isRequired", "value"],

  data() {
    return {
      fields: [],
      rules: this.isRequired ? [ui.requiredRule] : [],
    };
  },

  mounted() {
    this.refresh();
  },

  methods: {
    async refresh() {
      var response = await this.$store.dispatch("cache/getTables");
      this.fields = response;
    },
    onChange(e) {
      this.$emit("input", e);
    },
  },
};
</script>
